// extracted by mini-css-extract-plugin
export default {"question":"Tooltip_question__3I1Lb","tooltip":"Tooltip_tooltip__tIirw"};